export default function After(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="151" height="218" viewBox="0 0 151 218" fill="none" {...props}>
            <path
                d="M95.6162 61.4635L116.545 54.2288C117.331 53.9572 117.609 52.9887 117.087 52.3416L107.848 40.878C107.33 40.2356 106.334 40.2953 105.896 40.9949L94.2067 59.6932C93.6068 60.6528 94.5467 61.8332 95.6162 61.4635Z"
                fill="url(#paint0_linear_950_5871)"
                stroke="url(#paint1_linear_950_5871)"
                strokeWidth="0.4"
            />
            <circle
                cx="123.008"
                cy="4.04919"
                r="3.2"
                transform="rotate(-0.947326 123.008 4.04919)"
                fill="url(#paint2_linear_950_5871)"
                stroke="url(#paint3_linear_950_5871)"
                strokeWidth="0.4"
            />
            <circle
                cx="94.484"
                cy="214.55"
                r="3.2"
                transform="rotate(-0.947326 94.484 214.55)"
                fill="url(#paint4_linear_950_5871)"
                stroke="url(#paint5_linear_950_5871)"
                strokeWidth="0.4"
            />
            <circle
                cx="4.04919"
                cy="68.0248"
                r="3.2"
                transform="rotate(-0.947326 4.04919 68.0248)"
                fill="url(#paint6_linear_950_5871)"
                stroke="url(#paint7_linear_950_5871)"
                strokeWidth="0.4"
            />
            <path
                d="M148.692 129.67C148.904 129.529 148.945 129.253 148.931 128.991C148.916 128.71 148.836 128.352 148.702 127.932C148.435 127.089 147.94 125.953 147.262 124.606C145.906 121.91 143.804 118.343 141.279 114.544C138.753 110.745 136.278 107.427 134.317 105.133C133.338 103.987 132.481 103.091 131.808 102.518C131.472 102.233 131.173 102.019 130.92 101.897C130.684 101.783 130.414 101.714 130.201 101.855C129.989 101.996 129.949 102.272 129.962 102.534C129.977 102.815 130.058 103.173 130.191 103.593C130.459 104.436 130.954 105.572 131.631 106.919C132.987 109.615 135.089 113.181 137.615 116.98C140.14 120.779 142.615 124.097 144.576 126.391C145.556 127.537 146.412 128.434 147.085 129.007C147.421 129.292 147.72 129.505 147.973 129.627C148.21 129.741 148.48 129.811 148.692 129.67Z"
                fill="url(#paint8_linear_950_5871)"
                stroke="url(#paint9_linear_950_5871)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_950_5871" x1="75.991" y1="64.7495" x2="79.4129" y2="35.3813" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_950_5871" x1="87.67" y1="68.1718" x2="80.7543" y2="59.1955" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_950_5871" x1="126.008" y1="-2.51332" x2="130.697" y2="4.24335" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_950_5871" x1="122.591" y1="-0.835433" x2="126.462" y2="-0.715334" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_950_5871" x1="97.484" y1="207.987" x2="102.174" y2="214.744" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_950_5871" x1="94.0677" y1="209.665" x2="97.9386" y2="209.785" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_950_5871" x1="7.0492" y1="61.4623" x2="11.739" y2="68.2189" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_950_5871" x1="3.63288" y1="63.1402" x2="7.50376" y2="63.2603" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_950_5871" x1="121.13" y1="84.597" x2="129.804" y2="80.7881" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_950_5871" x1="124.343" y1="93.5431" x2="126.499" y2="92.1212" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
